import React, { useCallback, useEffect, useState } from 'react'
import { TradingAccountDetailDto } from 'api/Clients/Types/TradingAccountDetails'
import { PlatformTransactionTypeDto } from 'api/Trading-Accounts/Types/PlatformTransactionTypeDto'
import { useAppDispatch, useAppSelector } from 'store'
import { fetchInstrumentsAction } from 'store/trading-accounts/trading-accounts.actions'
import { PageQuery } from 'utils/api'
import { useApiClient } from 'utils/api/ApiClient'
import { TradingAccountsApiClient } from 'utils/api/tradingAccountsApi'
import { useFetchOne } from 'utils/api/useFetch'
import { isEmpty } from 'utils/is-empty'

import { LiveTradingAccountNavigation } from '../Navigation/LiveTradingAccountNavigation'
import { TradingAccountTab } from '../Navigation/TradingAccountNavigation'
import TradingAccountPlatformTransactionDetailsTable from './TradingAccountPlatformTransactionDetailsTable'

interface Props {
  data: TradingAccountDetailDto
}

const TradingAccountPlatformTransactionDetailsPage: React.FC<Props> = ({
  data: tradingAccount,
}) => {
  const tradingAccountsApiClient = useApiClient(TradingAccountsApiClient)

  const dispatch = useAppDispatch()

  const [gridQuery, setGridQuery] = useState<PageQuery>({})
  const [platformTransactionTypes, setPlatformTransactionTypes] = useState<
    PlatformTransactionTypeDto[]
  >([])

  const symbols = useAppSelector((state) => state.tradingAccounts.instruments)

  const fetchData = useCallback(() => {
    return tradingAccountsApiClient.getTradingAccountPlatformTransaction(tradingAccount.id, {
      ...gridQuery,
      skipCount: gridQuery.skipCount ?? true,
    })
  }, [tradingAccount.id, gridQuery]) // eslint-disable-line react-hooks/exhaustive-deps
  const { data, isLoading } = useFetchOne(fetchData)

  const getPlatformTransactionTypes = async () => {
    const response = await tradingAccountsApiClient.getPlatformTransactionTypes(
      tradingAccount.accountGroup.platformType.id
    )

    setPlatformTransactionTypes(response)
  }
  useEffect(() => {
    if (isEmpty(symbols)) {
      dispatch(fetchInstrumentsAction(tradingAccountsApiClient))
    }
    getPlatformTransactionTypes()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const handleGridChange = (pageQuery: PageQuery) => {
    setGridQuery(pageQuery)
  }

  return (
    <React.Fragment>
      <LiveTradingAccountNavigation
        data={tradingAccount}
        isEdit={false}
        tab={TradingAccountTab.PlatformTransactions}
      />
      <TradingAccountPlatformTransactionDetailsTable
        platformTransactionTypes={platformTransactionTypes}
        platformTransactions={data}
        gridQuery={gridQuery}
        isLoading={isLoading}
        onChange={handleGridChange}
      />
    </React.Fragment>
  )
}

export default TradingAccountPlatformTransactionDetailsPage
